// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { ButtonItem } from '@atlaskit/side-navigation';
import * as colors from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { Section } from '@atlassian/eoc-section';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledExpandableSection = styled(Section)({
	marginTop: token('space.200', '16px'),
	marginBottom: token('space.250', '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const StyledExpandableSectionTitle = styled.div({
	font: token('font.body.small'),
	fontWeight: token('font.weight.bold'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N300),
	margin: `0 0 0 ${token('space.negative.100', '-8px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledMoreText = styled.p({
	marginTop: 0,
	padding: token('space.100', '8px'),
	color: token('color.text.information', '#0055CC'),
	cursor: 'pointer',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledButtonItem = styled(ButtonItem)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:not(:hover, :focus, :active, :focus-visible, :focus-within)': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'.action-wrapper': {
			visibility: 'hidden',
		},
	},
	marginBottom: token('space.025', '2px'),
});
